import classNames from 'classnames'
import styles from './Card.module.scss'
import type { CardProps } from './types'
import { CardSpacing, CardVariant } from './types'

const Card = ({
  spacing = CardSpacing.compact,
  variant = CardVariant.outlined,
  children,
  className,
  ...rest
}: CardProps) => {
  return (
    <div
      className={classNames(styles['pintxo-card'], className)}
      data-spacing={spacing}
      data-variant={variant}
      {...rest}
    >
      {children}
    </div>
  )
}

export default Card
